import React from 'react';

export default function SocialLinks() {
  return (
    <div className="social-links">
      <a href="https://linkedin.com/in/helikadakia/" target="_blank" rel="noreferrer">
        <i className="fab fa-linkedin"></i>
      </a>
      <a href="https://github.com/hkadakia05" target="_blank" rel="noreferrer">
        <i className="fab fa-github"></i>
      </a>
      <a href="helikadakia05@gmail.com">
        <i className="fas fa-envelope"></i>
      </a>
    </div>
  );
}
